export default "__VITE_ASSET__CceWsysS__"